import { ClipboardCheck, X } from 'lucide-preact';
import { Button, IconButton } from '@/components/primitives';
import { cn } from '@/lib/cn';
import { hasReviewSurface, reviewMode, toggleReviewMode } from '@/stores/reviewMode';

const LEGEND =
  'Verde: dato disponible · Naranja: configuración o comprobación. No indica cumplimiento del objetivo.';

/**
 * Switch in the top bar. It only works on pages with data traces, but on desktop the
 * button always keeps its slot (invisible and inert elsewhere) so the top bar does not
 * jump when moving between pages with and without traces.
 */
export function ReviewModeToggle() {
  if (!hasReviewSurface.value) {
    return (
      <span aria-hidden="true" className="invisible hidden md:inline-flex">
        <Button size="sm" variant="default" leftIcon={ClipboardCheck} disabled tabIndex={-1}>
          Modo revisión
        </Button>
      </span>
    );
  }
  const active = reviewMode.value;
  return (
    <>
      <Button
        size="sm"
        variant={active ? 'primary' : 'default'}
        leftIcon={ClipboardCheck}
        aria-pressed={active}
        title={LEGEND}
        onClick={toggleReviewMode}
        className="hidden md:inline-flex"
      >
        Modo revisión
      </Button>
      <IconButton
        size="sm"
        icon={ClipboardCheck}
        label="Modo revisión"
        aria-pressed={active}
        onClick={toggleReviewMode}
        className={cn('md:hidden', active && 'bg-brand-tint text-brand')}
      />
    </>
  );
}

/** Legend under the top bar while the mode is on, so the colours can be read. */
export function ReviewModeBar() {
  if (!hasReviewSurface.value || !reviewMode.value) return null;
  return (
    <div
      role="status"
      className="border-brand-tint-strong bg-brand-tint text-13 text-fg flex shrink-0 items-center gap-3 border-b px-4 py-2 md:px-8"
    >
      <ClipboardCheck size={16} className="text-brand shrink-0" aria-hidden="true" />
      <p className="min-w-0 flex-1">
        <span className="text-fg-strong font-medium">Revisando el origen de los datos.</span>{' '}
        {LEGEND} Pulsa un indicador para ver cómo se calcula.
      </p>
      <IconButton
        size="sm"
        icon={X}
        label="Salir de la revisión"
        variant="subtle"
        onClick={toggleReviewMode}
      />
    </div>
  );
}
